import { ENVIRONMENT } from "src/scenes/App";

const nowhere = () => false;
const localhostOnly = () => ENVIRONMENT.get() === ENVIRONMENT.DEV;
const notProductionReady = () => ENVIRONMENT.get() !== ENVIRONMENT.PRODUCTION;

export const IsFeatureReady = {
    signUpButton: notProductionReady,
    darkMode: localhostOnly,
    interactionRateStat: notProductionReady,
    clientQuoteCategorySelection: notProductionReady,
    calendarIntegrations: notProductionReady,
    calendarMeetingRequests: nowhere,
    calendarGuestInvites: nowhere,
    callTextRecordings: localhostOnly,
    publicMeetings: () => true,
    storageManagement: notProductionReady
};
